import client from './client'

const apiBasePath = '/api/search-company/'

export default {
  search: body => client.post(apiBasePath + 'search', body)
}
